module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0005.3af91827.jpg";